import apiClient from "../../../api/client";

export const getEmployeeVacations = (employeeId, month, year, options = {}) => {
  const queryParams = new URLSearchParams();
  if (month) queryParams.append("month", month);
  if (year) queryParams.append("year", year);
  if (options.includePending) queryParams.append("includePending", "true");

  return apiClient
    .get(`/vacations/employee/${employeeId}?${queryParams.toString()}`)
    .then((res) => res.data);
};

export const getCompanyVacations = (month, year) => {
  const queryParams = new URLSearchParams();
  if (month) queryParams.append("month", month);
  if (year) queryParams.append("year", year);

  return apiClient
    .get(`/vacations/company?${queryParams.toString()}`)
    .then((res) => res.data);
};

export const getVacationsCalendar = (month, year) => {
  return apiClient
    .get(`/vacations/calendar?month=${month}&year=${year}`)
    .then((res) => res.data);
};

export const updateVacationStatusApi = ({ vacationId, status, notes }) => {
  return apiClient
    .patch(`/vacations/${vacationId}/status`, { status, notes })
    .then((res) => res.data);
};

export const updateVacationRequestApi = ({ vacationId, data }) => {
  return apiClient.put(`/vacations/${vacationId}`, data).then((res) => res.data);
};

// Owner actions on your own request (no admin permission needed)
export const updateMyVacationRequestApi = ({ vacationId, data }) => {
  return apiClient.put(`/vacations/${vacationId}/my`, data).then((res) => res.data);
};

export const cancelMyVacationRequestApi = (vacationId) => {
  return apiClient.post(`/vacations/${vacationId}/cancel`).then((res) => res.data);
};

export const createVacationRequestApi = (data) => {
  return apiClient.post("/vacations", data).then((res) => res.data);
};

export const checkAvailabilityApi = (checks, excludeTaskId) => {
  return apiClient
    .post("/vacations/check-availability", { checks, excludeTaskId })
    .then((res) => res.data);
};

export const getOverlappingTasksApi = (vacationId) => {
  return apiClient.get(`/vacations/${vacationId}/overlapping-tasks`).then((res) => res.data);
};

export const notifyReporterApi = ({ vacationId, taskId }) => {
  return apiClient.post(`/vacations/${vacationId}/notify-reporter`, { taskId }).then((res) => res.data);
};
